import { useState, useContext, useEffect } from "react";
import "./navDrawer.scss";
import { Drawer } from "antd";
import { useNavigate, useLocation } from "react-router-dom";

// context
import { AppContext } from "../../contexts/appCotext";
import { AuthContext } from "../../contexts/authContext";

// images
import { images } from "../../constants/images";

// icon
import {
  userIcon,
  closeIcon,
  piechartIcon,
  questionMarkIcon,
  listIcon,
  logoutIcon,
} from "../../constants/icons";

const NavDrawer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { navDrawer, toggleNavDrawer } = useContext(AppContext);
  const { user, logoutUser } = useContext(AuthContext);
  const [path, setPath] = useState<string>("");

  const [activeTab, setActiveTab] = useState<string>("evaluation");

  const handleLogout = async () => {
    try {
      const res = await logoutUser();
      if (res.status === 200 && res.success === true) {
        toggleNavDrawer();
        return navigate("/");
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (
      location.pathname === "/" ||
      location.pathname === "/auth/signin" ||
      location.pathname === "/auth/signup"
    ) {
      setPath("landing");
    } else {
      setPath("dashboard");
      let pathsplit = location.pathname.split("/");
      setActiveTab(pathsplit[2]);
    }
  }, [location.pathname]);

  return (
    <Drawer onClose={toggleNavDrawer} open={navDrawer} closable={false}>
      <div className="navDrawerContainer">
        <div className="logoHolder">
          <div className="logo">
            <img src={images.logo} alt="Logo" />
          </div>
          <div className="appName">
            <span className="title">HAIQU</span>
            <span>Human-AI QUestionnaire</span>
          </div>
          <button className="closeNavDrawer" onClick={toggleNavDrawer}>
            {closeIcon}
          </button>
        </div>
        {path === "landing" && (
          <div className="authButtons">
            <button
              className="signin"
              onClick={() => {
                toggleNavDrawer();
                navigate("/auth/signin");
              }}
            >
              Sign-in
            </button>
            <button
              className="signup"
              onClick={() => {
                toggleNavDrawer();
                navigate("/auth/signup");
              }}
            >
              Sign-up
            </button>
          </div>
        )}
        {path === "dashboard" && (
          <>
            <div className="dashboardTabs">
              {user.role === "admin" && (
                <>
                  <span
                    className={`${activeTab === "users" && "active"}`}
                    onClick={() => {
                      toggleNavDrawer();
                      navigate("/dashboard/users");
                    }}
                  >
                    {userIcon} Users
                  </span>
                  <span
                    className={`${activeTab === "catalog" && "active"}`}
                    onClick={() => {
                      toggleNavDrawer();
                      navigate("/dashboard/catalog");
                    }}
                  >
                    {listIcon} Catalog
                  </span>
                </>
              )}
              <span
                className={`${activeTab === "evaluation" && "active"}`}
                onClick={() => {
                  toggleNavDrawer();
                  navigate("/dashboard/evaluation");
                }}
              >
                {piechartIcon} You evaluations
              </span>
              <span
                className={`${activeTab === "about" && "active"}`}
                onClick={() => {
                  toggleNavDrawer();
                  navigate("/dashboard/about");
                }}
              >
                {questionMarkIcon} What is HAIQU?
              </span>
            </div>
            <div className="logoutHolder">
              <span onClick={handleLogout}>{logoutIcon} Logout</span>
            </div>
          </>
        )}
      </div>
    </Drawer>
  );
};

export default NavDrawer;
